import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_pie chart",
  "use": "icon-icon_pie chart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_pie chart\"><defs><style></style></defs><path d=\"M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0zm460.186 489.882H537.6V52.019a461.21 461.21 0 0 1 434.586 437.863zm0 51.2a458.752 458.752 0 0 1-93.39 249.446L582.043 541.082zM512 972.8a460.8 460.8 0 0 1-25.6-921.6v464.282a25.805 25.805 0 0 0 9.83 20.48L845.62 829.44A459.776 459.776 0 0 1 512 972.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol